import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=dec857a2&scoped=true&"
import script from "./DetailItem.vue?vue&type=script&lang=js&"
export * from "./DetailItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailItem.vue?vue&type=style&index=0&id=dec857a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec857a2",
  null
  
)

export default component.exports